<div class="row-wrapper col-md-12 margin-bottom10">
	<label class="question-green">{{ groupTitle }}</label>
	@if (changed) {
		<div class="change-box reviewer">{{ 'change-label-component.application-reviewer-change' | translate }}</div>
	}
</div>
<div class="row-wrapper col-md-12">
	@for (file of fileDetails; track file.md5) {
		<a class="file-button details" (click)="downloadDocument(file)">
			<nb-icon status="primary" icon="download" class="button-icon"></nb-icon>
			<div title="{{file.fileName}}" style="max-width: 300px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap">{{ file.fileName }}</div>
		</a>
	}
</div>
